<template>
  <div class="footer">
    <div>
      <strong>Copyright</strong> {{ year }} ColonyHQ Pty Ltd.
    </div>
    <div class="footer-link">
      <a href="https://colonylive.b-cdn.net/wp-content/uploads/2021/03/COLONYLive-web-Privacy-policy.pdf" target="_blank">
        Privacy Policy
      </a>
    </div>
    <div class="footer-link">
      <a href="https://colonylive.b-cdn.net/wp-content/uploads/2021/03/Web-Copy-TandC.pdf" target="_blank">
        Terms & Conditions
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  position: absolute;
  clear: all;
  z-index: 99;

  div {
    display: inline-block;
  }
}

.footer-link {
  margin-left: 10px;
  padding-left: 10px;
  border-left: 1px solid #ddd;
}
</style>



// WEBPACK FOOTER //
// AppFooter.vue?b47eb8c4